import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { StatusLabelProps } from '../../helpers/types';

const statusLabel = {
  padding: '4px 10px',
  borderRadius: '16px',
  fontSize: '12px',
  fontFamily: 'Poppins', //hardcoded for speed
  whiteSpace: 'nowrap',
  width: 'fit-content',
  '&::first-letter': {
    textTransform: 'uppercase'
  }
};

const StatusLabel = ({ label, bgcolor, style }: StatusLabelProps) => {
  const theme = useTheme();
  return <Box sx={{
    border: `1px solid ${bgcolor}`,
    color: bgcolor,
    background: theme.palette.background.paper,
    ...statusLabel
  }} style={style}>{label}</Box>;
};

export default StatusLabel;
